// frontend/src/components/games/GameCard.tsx

import { Link } from 'react-router-dom';
import { GameDefinition } from '../../config/games';

interface GameCardProps {
  game: GameDefinition;
}

export function GameCard({ game }: GameCardProps) {
  const isAvailable = game.status === 'available';

  return (
    <div className={`game-card ${isAvailable ? '' : 'coming-soon'}`}>
      {!isAvailable && <span className="game-card-badge">Yakında</span>}
      <div className="game-card-icon">{game.emoji}</div>
      <h3 className="game-card-title">{game.title}</h3>
      <p className="game-card-desc">{game.description}</p>
      {isAvailable ? (
        <Link to={game.path} className="game-card-btn primary">
          ▶ Oyna
        </Link>
      ) : (
        <button type="button" className="game-card-btn disabled" disabled>
          🔒 Yakında
        </button>
      )}
    </div>
  );
}
